var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    [
      _c(
        "h2",
        { staticClass: "display-2 mb-4" },
        [
          _c(
            "v-icon",
            { staticClass: "mr-2", attrs: { large: "", color: "primary" } },
            [_vm._v("person")]
          ),
          _vm._v("\n    " + _vm._s(_vm.$t("App.UserProfile")) + "\n  "),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "mb-4" },
        [
          _c(
            "v-card-title",
            { staticClass: "headline white--text info" },
            [
              _c("v-icon", { staticClass: "mr-2", attrs: { color: "white" } }, [
                _vm._v("account_box"),
              ]),
              _vm._v("\n      Account Information\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            { staticClass: "pa-0" },
            [
              _c(
                "v-list",
                { attrs: { "two-line": "" } },
                [
                  _c(
                    "v-list-tile",
                    [
                      _c(
                        "v-list-tile-avatar",
                        [
                          _c("v-icon", { attrs: { color: "info" } }, [
                            _vm._v("person"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [_vm._v("Username")]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-sub-title",
                            { staticClass: "font-weight-medium" },
                            [_vm._v(_vm._s(_vm.profile.UserName || "—"))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider", { attrs: { inset: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    [
                      _c(
                        "v-list-tile-avatar",
                        [
                          _c("v-icon", { attrs: { color: "info" } }, [
                            _vm._v("email"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [_vm._v("Email")]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-sub-title",
                            { staticClass: "font-weight-medium" },
                            [_vm._v(_vm._s(_vm.profile.Email || "—"))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider", { attrs: { inset: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    [
                      _c(
                        "v-list-tile-avatar",
                        [
                          _c("v-icon", { attrs: { color: "info" } }, [
                            _vm._v("business"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [_vm._v("Tenant")]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-sub-title",
                            { staticClass: "font-weight-medium" },
                            [_vm._v(_vm._s(_vm.profile.TenantName || "—"))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("v-divider", { attrs: { inset: "" } }),
                  _vm._v(" "),
                  _c(
                    "v-list-tile",
                    [
                      _c(
                        "v-list-tile-avatar",
                        [
                          _c("v-icon", { attrs: { color: "info" } }, [
                            _vm._v("security"),
                          ]),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-list-tile-content",
                        [
                          _c("v-list-tile-title", [_vm._v("Role(s)")]),
                          _vm._v(" "),
                          _c(
                            "v-list-tile-sub-title",
                            { staticClass: "font-weight-medium" },
                            [_vm._v(_vm._s(_vm.rolesDisplay || "—"))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "mb-4" },
        [
          _c(
            "v-card-title",
            { staticClass: "headline white--text secondary" },
            [
              _c("v-icon", { staticClass: "mr-2", attrs: { color: "white" } }, [
                _vm._v("vpn_key"),
              ]),
              _vm._v("\n      Access Token\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-card-text",
            [
              _c(
                "v-layout",
                { attrs: { row: "", "align-center": "" } },
                [
                  _c("v-flex", { attrs: { grow: "" } }, [
                    _c("div", { staticClass: "token-display" }, [
                      _vm._v(_vm._s(_vm.maskedToken)),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "v-flex",
                    { attrs: { shrink: "" } },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            icon: "",
                            color: _vm.copied ? "success" : "accent",
                          },
                          on: { click: _vm.copyToken },
                        },
                        [
                          _c("v-icon", [
                            _vm._v(
                              _vm._s(_vm.copied ? "check" : "mdi-content-copy")
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "caption mt-2" },
                [
                  _c("v-icon", { staticClass: "mr-1", attrs: { small: "" } }, [
                    _vm._v("schedule"),
                  ]),
                  _vm._v(
                    "\n        Expires: " + _vm._s(_vm.tokenExpiry) + "\n      "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-card",
        { staticClass: "mb-4" },
        [
          _c(
            "v-card-title",
            { staticClass: "headline white--text error" },
            [
              _c("v-icon", { staticClass: "mr-2", attrs: { color: "white" } }, [
                _vm._v("lock"),
              ]),
              _vm._v("\n      Change Password\n    "),
            ],
            1
          ),
          _vm._v(" "),
          _c("v-divider"),
          _vm._v(" "),
          _c(
            "v-form",
            {
              ref: "passwordFormRef",
              attrs: { "lazy-validation": "" },
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                  return _vm.changePassword.apply(null, arguments)
                },
              },
            },
            [
              _c(
                "v-card-text",
                [
                  _c(
                    "v-alert",
                    {
                      attrs: {
                        value: true,
                        color: "warning",
                        icon: "warning",
                        outline: "",
                      },
                    },
                    [
                      _vm._v(
                        "\n          Changing your password will log you out of all active sessions. You will need to sign in again with your new password.\n        "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      label: "Current Password",
                      type: "password",
                      box: "",
                      "prepend-icon": "lock_open",
                      rules: [_vm.rules.required],
                    },
                    model: {
                      value: _vm.passwordForm.CurrentPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.passwordForm, "CurrentPassword", $$v)
                      },
                      expression: "passwordForm.CurrentPassword",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      label: "New Password",
                      type: "password",
                      box: "",
                      "prepend-icon": "lock",
                      rules: _vm.newPasswordRules,
                      hint: "Minimum 6 characters",
                      "persistent-hint": "",
                    },
                    model: {
                      value: _vm.passwordForm.NewPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.passwordForm, "NewPassword", $$v)
                      },
                      expression: "passwordForm.NewPassword",
                    },
                  }),
                  _vm._v(" "),
                  _c("v-text-field", {
                    attrs: {
                      label: "Confirm New Password",
                      type: "password",
                      box: "",
                      "prepend-icon": "lock",
                      rules: _vm.confirmPasswordRules,
                    },
                    model: {
                      value: _vm.passwordForm.ConfirmPassword,
                      callback: function ($$v) {
                        _vm.$set(_vm.passwordForm, "ConfirmPassword", $$v)
                      },
                      expression: "passwordForm.ConfirmPassword",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "pa-3" },
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "error",
                        type: "submit",
                        loading: _vm.isSubmitting,
                        disabled: _vm.isSubmitting,
                        large: "",
                      },
                    },
                    [
                      _c("v-icon", { attrs: { left: "" } }, [_vm._v("save")]),
                      _vm._v("\n          Change Password\n        "),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }